<div class="main-page">
	<!-- <nav class="navbar navbar-expand-lg navbar-light bg-light header">
		<div class="logo"><a (click)="redirect()"><img src="assets/logo-4.png"></a></div>
	</nav> -->
	<app-header></app-header>
	<app-side-bar></app-side-bar>
	<div class="container">
		<div class="setting-text-area">
			<div class="innerPage setting-text-area-inner">
				<div class="pg-view-header">
          <div>
            <div class="pg-view-title">Photo Gallery</div>
            <div class="pg-view-subtitle">Your public gallery images</div>
          </div>
          <button routerLink='/add-photo-gallery' class="pg-view-action">
            Manage Photos
          </button>
        </div>
                <div class="row">
                    <div class="col-12">
                        <div>
                            <!-- <app-no-results-found *ngIf="objArr.length == 0 " title='Photo Gallery'>
                            </app-no-results-found> -->
                            <div class="pg-view-grid">
                                <div class="pg-view-item"
                                    *ngFor="let props of  objArr.slice(0, photoLimit); let i = index">
                                    <!-- <div class="position-2 cursor" (click)="deleteImages(i)"> &#10005;</div> -->
                                    <div *ngIf="arr[i]?.deleteImage" class="spinner-border text-muted"
                                        style="position:absolute; top:40%; left:40%;"></div>

                                    <div class="pg-view-img">
                                        <img
                                          [src]="renderImage(props)"
                                          alt="Gallery image"
                                          (error)="onImgError($event)"
                                        >
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
			</div>
		</div>
	</div>
</div>
